export default __webpack_public_path__ + "img/jo.png";